// Rebuy bundle builder: show the page's custom.bundle_sidebar_text metafield below the sidebar title.
// Rebuy renders and re-renders the sidebar client-side, so the line is re-inserted whenever it goes missing.
(function () {
  const HEADER_SEL = '.rebuy-bundle-builder__group-container-header';
  const TEXT_CLASS = 'rebuy-bundle-builder__sidebar-text';
  const text = document.currentScript && document.currentScript.dataset.text;

  if (!text) return;

  function insert() {
    document.querySelectorAll(HEADER_SEL).forEach(function (header) {
      const next = header.nextElementSibling;
      if (next && next.classList.contains(TEXT_CLASS)) return;

      const el = document.createElement('p');
      el.className = TEXT_CLASS;
      el.textContent = text;
      header.after(el);
    });
  }

  new MutationObserver(insert).observe(document.body, { childList: true, subtree: true });

  insert();
})();
